<template>
  <div>
    <!-- Show one applicant -->
    <applicant
      :showApplicant="showApplicant"
      @close="handleCloseApplicant"
    ></applicant>

    <div
      @click="close"
      class="
        flex
        items-center
        gap-2
        m-3
        cursor-pointer
        rounded-full
        w-max p-2
        justify-center
        text-sm
        bg-white
      "
    >
      <img class="h-4 object-contain" src="@/assets/icons/left.png" />
      <p>Back to Applications</p>
    </div>
    <div class="bg-white m-3 rounded-md">
      <div class="border-b-0.5 flex flex-wrap lg:gap-0 gap-4 justify-between items-center p-3">
        <p class="text-sm font-semibold">Sales Manager</p>
        <div class="flex gap-10">
          <div class="flex gap-4">
            <input
              type="text"
              placeholder="Search Applicant"
              class="rounded-xl w-full px-4 bg-gray-200"
            />
            <select class="rounded-xl w-full px-4 bg-gray-200">
              <option>Recruitment Step</option>
            </select>
          </div>
          <!-- <button class="bg-primary text-white rounded-full px-3 py-1 text-sm">
            Add Applicant
          </button> -->
        </div>
      </div>
      <div class="p-2">
        <ve-table :columns="columns" :table-data="tableData" />
      </div>
    </div>
  </div>
</template>


<script>
import Applicant from "./applicant.vue";
export default {
  name: "ApplicationsPerPosition",
  components: { Applicant },
  data() {
    return {
      showApplicant: false,
      columns: [
        {
          field: "",
          key: "numbering",
          title: "",
          width: 50,
          align: "center",
          renderBodyCell: ({ rowIndex }) => {
            return ++rowIndex;
          },
        },
        {
          field: "Name",
          key: "a",
          title: "Applicant Name",
          align: "left",
          renderBodyCell: ({ row }) => {
            return (
              <div class="flex gap-5 items-center">
                <div class="h-8 w-8 rounded-full">
                  <img
                    class="h-full w-full rounded-full"
                    src="https://cdn2.iconfinder.com/data/icons/flatfaces-everyday-people-square/128/african_flatcut_boy_man_black_face_avatar-512.png"
                  />
                </div>
                <p
                  on-click={() => this.openApplicant()}
                  class="text-blue-500 cursor-pointer"
                >
                  {row.Name}
                </p>
              </div>
            );
          },
        },
        {
          field: "Step",
          key: "b",
          title: "Recruitment Step",
          renderBodyCell: ({ row }) => {
            return (
              <span class="cursor-pointer bg-gray-200 lg:px-4 px-1 text-sm py-2 rounded-full">
                {row.Step}
              </span>
            );
          },
        },
        { field: "Reviewer", key: "c", title: "Current Reviewer" },

        {
          field: "Action",
          key: "f",
          title: "Action",
          renderBodyCell: () => {
            return (
              <p class="cursor-pointer transform rotate-90 font-bold">
                &#8230;
              </p>
            );
          },
        },
      ],
      tableData: [
        {
          Name: "Alexander Cortez",
          Step: "CV Review",
          Reviewer: "John Doe",
          Action: "",
        },
        {
          Name: "Alexander Cortez",
          Step: "CV Review",
          Reviewer: "John Doe",
          Action: "",
        },
        {
          Name: "Alexander Cortez",
          Step: "CV Review",
          Reviewer: "John Doe",
          Action: "",
        },
        {
          Name: "Alexander Cortez",
          Step: "CV Review",
          Reviewer: "John Doe",
          Action: "",
        },
        {
          Name: "Alexander Cortez",
          Step: "CV Review",
          Reviewer: "John Doe",
          Action: "",
        },
        {
          Name: "Alexander Cortez",
          Step: "CV Review",
          Reviewer: "John Doe",
          Action: "",
        },
      ],
    };
  },
  methods: {
    close() {
      this.$emit("close");
    },
    openApplicant() {
      this.showApplicant = true;
    },
    handleCloseApplicant() {
      this.showApplicant = false;
    },
  },
};
</script>